module.exports = __webpack_public_path__ + "img/select.a01c7eff.png";